import { Component, OnInit } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ViewPdfComponent2 } from "../view-pdf2/viewPdf2.component";

@Component({
  selector: "app-bike-view",
  templateUrl: "./bike-view.component.html",
})
export class BikeViewComponent implements OnInit {
  data;
  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,

  ) {}

  ngOnInit() {
  }

  closeModal() {
    this.activeModal.dismiss("close");
  }
  openModalViewPdf() {
    const modalRef = this.modalService.open(ViewPdfComponent2, {
      backdrop: "static",
      centered: true,
      size: 'lg'
    });
    modalRef.componentInstance.data = this.data.userProductBill.billPhoto;
    modalRef.result
      .then((result) => {
      })
      .catch((error) => {});
  }
}
